import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { H1 } from "../typography"
import Card from "../card"
import { StyledHeading, Container } from "./styles"

const Header = ({ title, gridArea, image, simpleFormLayout, homePage }) => {
  return (
    <>
      {!!simpleFormLayout ? (
        <Fragment>
          <StyledHeading>{title}</StyledHeading>
        </Fragment>
      ) : (
        <Container gridArea={gridArea} className="ho-header">
          {!!image ? (
            <Card variant="primary" image={image} roundedOnMobile={false}>
              <H1 size="3xlarge" marginless>
                {title}
              </H1>
            </Card>
          ) : (
            <Card variant="primary" gradient pageMargin desktopOnly={homePage}>
              <H1 size="large" marginless>
                {title}
              </H1>
            </Card>
          )}
        </Container>
      )}
    </>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  gridArea: PropTypes.string,
  image: PropTypes.string
}

Header.defaultProps = {
  gridArea: undefined,
  image: undefined
}

export default Header
